(function () {
  const THRESHOLD = 120;
  const links = new Set();
  let scrollBound = false;

  function updateVisibility() {
    const show = window.scrollY > THRESHOLD;

    links.forEach((link) => {
      link.classList.toggle('is-visible', show);
      link.setAttribute('aria-hidden', show ? 'false' : 'true');
      link.tabIndex = show ? 0 : -1;
    });
  }

  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
  }

  function initLink(link) {
    if (link.dataset.llavesBackInit) return;
    link.dataset.llavesBackInit = 'true';
    links.add(link);

    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    updateVisibility();
  }

  function init() {
    document.querySelectorAll('.llaves-shop__back-to-top').forEach(initLink);
    bindScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
